import dynamic from 'next/dynamic'
import Head from 'next/head'
import firebase_app from '../../lib/firebaseConfig'
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";

import { getDynamicPageHeadData } from '../../constants/mainFunctions'
import LoadingComponent from '../../components/shared/loadingComponent'
const CurrentCoinMainComponent = dynamic(() => import('../../components/pagesCpmponents/currrentCoinComponets/currentCoinMainComponent'), {
    loading: () => <LoadingComponent />,
})
const CurrentCoinFeatureProducts = dynamic(() => import('../../components/pagesCpmponents/currrentCoinComponets/currentCoinFeatureProducts'), {
    loading: () => <LoadingComponent />,
})
const CurrentCoinContact = dynamic(() => import('../../components/pagesCpmponents/currrentCoinComponets/currentCoinContact'), {
    loading: () => <LoadingComponent />,
})
const PagaeLoad = dynamic(() => import('../../components/animations/pageLoad'))


const db = getFirestore(firebase_app);

export async function getStaticPaths() {
    
    let coinsArray = []

    try {
        
        const coinRef = collection(db, "coinData");

        const q = query(coinRef, where("world", "==", "y"), where("archive", "==", "n"));
        const querySnapshot = await getDocs(q);
  
        await querySnapshot.forEach((doc) => {           
            coinsArray.push({ ...doc.data() })
        });
          
        const paths = coinsArray?.map((e) => ({ params: { id: `${e?.docId}` }, }))
        
        return {
            paths,
            fallback: false,
        }

    } catch (e) {
        return {
            paths: [],
            fallback: false, 
        }
    }
}

export async function getStaticProps({ params }) {

    const coinId = params?.id
    let singleCoin1 = []
    let itemsArray1 = [];
    let singleCoin = []
    let itemsArray = [];

    try {        
        const coinRef = collection(db, "coinData");

        const q = query(coinRef, where("docId", "==", `${coinId}`));
        const querySnapshot = await getDocs(q);
   
        await querySnapshot.forEach((doc) => {
            singleCoin1.push({ ...doc.data() })
        });
            
        //find country for featured imgs
        if (singleCoin1 !== undefined && singleCoin1 !== null) {

            const coinCountry = singleCoin1[0].country

            const q = query(coinRef, where("country", "==", `${coinCountry}`));
            const querySnapshot2 = await getDocs(q);           
            await querySnapshot2.forEach((doc) => {
                itemsArray1.push({ ...doc.data() })
            });
        }

        if (singleCoin1 !== undefined && singleCoin1 !== null) {

            singleCoin = await JSON.stringify(singleCoin1, (_, docId) => typeof docId === 'bigint' ? docId.toString() : docId)
        }
        if (itemsArray1 !== undefined && itemsArray1 !== null) {

            itemsArray = await JSON.stringify(itemsArray1, (_, docId) => typeof docId === 'bigint' ? docId.toString() : docId)
        }
  
        return {
            props: { singleCoin, itemsArray }
        }

    } catch (e) {

        return {
            props: { singleCoin: [], itemsArray: [] }
        }
    }
}

export default function WorldSingleCoin(props) {

    const { description, id, ogImg, myCoin } = getDynamicPageHeadData(props)

    const title = `${description} | Fl Gold Coin Exchange `

    return (< div className='homeBgImg'>
        <Head>
            <title>{title}</title>
            <meta keywords="World coins" />
            <meta name="description" content={description} />
            <link rel="canonical" href={`${process.env.siteUrl}/worldCoins/${id}`} />
            <meta property="og:url" content={`${process.env.siteUrl}/worldCoins/${id}`} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={`${process.env.NEXT_PUBLIC_IMAGE_AWS_URL}/${ogImg}`} />
            <meta name="AdsBot-Google" content="index" />
            <meta name="robots" content="index, follow" />
        </Head>
        <PagaeLoad>
            <CurrentCoinMainComponent
                data={myCoin}
            />
            <CurrentCoinContact />
            <CurrentCoinFeatureProducts
                coinLink={'worldCoins'}
                data={props}
            />
        </PagaeLoad>
    </div>
    )
}
